export default {
    name    : "receivable",
    data    : () => ({
        items  : {
            purchases      : [],
            sales          : [],
            purchase_return: {},
            sale_return    : {},
        },
        loading: false,
    }),
    created() {
        this.loading = true
        this.getData()
    },
    computed: {
        supplierBalance() {
            return this.items.purchases.purchase_paid - this.items.purchases.purchase_total
        },
        customerBalance() {
            return this.items.sales.sale_total - this.items.sales.sale_paid
        },
        totalBalance() {
            return this.supplierBalance + this.customerBalance + this.items.purchase_return.balance + this.items.sale_return.balance
        }
    },
    methods : {
        getData() {
            axios.get('/api/accounts/receivable', {params: this.options})
                 .then(res => {
                     this.items   = res.data
                     this.loading = false
                 })
        }
    }
}